import Vue from 'vue'
import VueSocketio from 'vue-socket.io-extended';
import io from 'socket.io-client';

const socketUrl = 'https://easytools-socketio.herokuapp.com/';
Vue.use(VueSocketio, io(socketUrl));